import { PatientSearchConstants } from './patientSearch.constants'
import { IPatientSearchAction, IPatientSearchState } from './patientSearch.types'

export const initialPatientSearchState: IPatientSearchState = {
  areResultsLoading: false,
  firstName: '',
  lastName: '',
  dOB: '',
  sSN: '',
  searchResults: [],
  selectedPtid: null,
  showImportDataConfirmationAlert: false,
  showSharedServiceSearchResultsMessage: false,
  totalAvailableResults: 0,
  totalSearchResults: 0,
  isPatientDataLoading: false,
  isSetSearchImport: false,
}

export function patientSearchReducer(
  state: IPatientSearchState = initialPatientSearchState,
  action: IPatientSearchAction
): IPatientSearchState {
  switch (action.type) {
    case PatientSearchConstants.SET_FIRST_NAME:
      return { ...state, firstName: action.firstName }
    case PatientSearchConstants.SET_LAST_NAME:
      return { ...state, lastName: action.lastName }
    case PatientSearchConstants.SET_DOB:
      return { ...state, dOB: action.dOB }
    case PatientSearchConstants.SET_SSN:
      return { ...state, sSN: action.sSN }
    case PatientSearchConstants.GET_PATIENT_RECORD:
      return { ...state, selectedPtid: action.selectedPtid }
    case PatientSearchConstants.SET_PATIENT_SEARCH_RESULTS:
      return { ...state, searchResults: action.searchResults }
    case PatientSearchConstants.SET_ARE_RESULTS_LOADING:
      return { ...state, areResultsLoading: action.areResultsLoading }
    case PatientSearchConstants.SET_IS_PATIENT_DATA_LOADING:
      return { ...state, isPatientDataLoading: action.isPatientDataLoading }
    case PatientSearchConstants.SET_SHOW_IMPORT_DATA_CONFIRMATION_ALERT:
      return { ...state, showImportDataConfirmationAlert: action.showImportDataConfirmationAlert }
    case PatientSearchConstants.SET_TOTAL_AVAILABLE_RESULTS:
      return { ...state, totalAvailableResults: action.totalAvailableResults }
    case PatientSearchConstants.SET_TOTAL_SEARCH_RESULTS:
      return { ...state, totalSearchResults: action.totalSearchResults }
    case PatientSearchConstants.SET_IS_SEARCH_IMPORT:
      return { ...state, isSetSearchImport: action.isSetSearchImport }
    case PatientSearchConstants.SET_SHOW_SHARED_SERVICE_SEARCH_RESULTS_MESSAGE:
      return { ...state, showSharedServiceSearchResultsMessage: action.showSharedServiceSearchResultsMessage }
    case PatientSearchConstants.SET_SEARCH_STATE:
      return { ...state, ...action.patientSearch }
    case PatientSearchConstants.RESET_SEARCH:
      return { ...state, firstName: '', lastName: '', dOB: '', sSN: '' }
    case PatientSearchConstants.RESET_SEARCH_STATE:
      return { ...initialPatientSearchState }
    default:
      return state
  }
}
